import Textarea from "../../../../../utils/components/Textarea";
import SelectBox from "../../../../../utils/components/SelectBox";
import timestampToDateFormat from "../../../../../utils/helpers/timestampToDateFormat";

const statusOptions = [
  { value: "Draft", label: "Draft" },
  { value: "Published", label: "Published" },
  { value: "Inactive", label: "Inactive" },
];

const GeneralInformation = ({
  name,
  status,
  createdAt,
  createdBy,
  modifiedAt,
  modifiedBy,
  version,
  id,
  handleAction,
  translate,
}) => {
  return (
    <div className="GeneralInformation container-fluid px-0">
      <div className="row d-flex flex-start">
        <div className="col-12 col-md-6">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.progress-settings-modal.workflow-name"
            )}
          </p>
          <Textarea
            className="form-control"
            placeholder={translate(
              "design_approval_process.progress-settings-modal.placeholders.enter-workflow-name"
            )}
            value={name}
            rows={1}
            onChange={(e) => handleAction({ name: e.target.value })}
          />
        </div>
        <div className="col-12 col-md-6">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.progress-settings-modal.created-at"
            )}
          </p>
          <p className="border border-gray border-2 rounded p-2 bg-light-page">
            {createdAt ? timestampToDateFormat(createdAt) : "N/A"}
          </p>
        </div>
        <div className="col-12 col-md-6 mt-3">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.progress-settings-modal.status"
            )}
          </p>
          <SelectBox
            options={statusOptions}
            onChange={(data) => handleAction({ status: data.value })}
            placeholder={translate(
              "design_approval_process.progress-settings-modal.placeholders.select-status"
            )}
            value={
              status
                ? statusOptions.find((item) => item.value === status)
                : null
            }
          />
        </div>
        <div className="col-12 col-md-6 mt-3">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.progress-settings-modal.created-by"
            )}
          </p>
          <p className="border border-gray border-2 rounded p-2 bg-light-page">
            {createdBy || "N/A"}
          </p>
        </div>
        <div className="col-12 col-md-6 mt-3">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.progress-settings-modal.workflow-id"
            )}
          </p>
          <p className="border border-gray border-2 rounded p-2 bg-light-page">
            {id || "N/A"}
          </p>
        </div>
        <div className="col-12 col-md-6 mt-3">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.progress-settings-modal.updated-at"
            )}
          </p>
          <p className="border border-gray border-2 rounded p-2 bg-light-page">
            {modifiedAt ? timestampToDateFormat(modifiedAt) : "N/A"}
          </p>
        </div>
        <div className="col-12 col-md-6 mt-3">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.uppercase_translates.input_titles.version"
            )}
          </p>
          <p className="border border-gray border-2 rounded p-2 bg-light-page">
            {version || "N/A"}
          </p>
        </div>
        <div className="col-12 col-md-6 mt-3">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate(
              "design_approval_process.progress-settings-modal.updated-by"
            )}
          </p>
          <p className="border border-gray border-2 rounded p-2 bg-light-page">
            {modifiedBy || "N/A"}
          </p>
        </div>
      </div>
      <div className="row"></div>
    </div>
  );
};
export default GeneralInformation;
